var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("timeline-item-card", {
    scopedSlots: _vm._u([
      {
        key: "body",
        fn: function () {
          return [
            _c("calendar-event-information", {
              attrs: {
                "event-details": _vm.metadata,
                "start-time": _vm.startTime,
                "end-time": _vm.endTime,
              },
            }),
          ]
        },
        proxy: true,
      },
      {
        key: "footer",
        fn: function () {
          return [
            _c("timeline-card-footer", {
              attrs: { "show-pin": false },
              scopedSlots: _vm._u([
                {
                  key: "left",
                  fn: function () {
                    return [
                      _c(
                        "b-col",
                        {
                          staticClass: "vertical-center mb-md-0 mb-2",
                          attrs: { cols: "12", md: "auto" },
                        },
                        [
                          _c("span", [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.$t("global.words.scheduled")) +
                                "\n            "
                            ),
                            _c(
                              "span",
                              {
                                staticClass:
                                  "text-secondary bold text-capitalize",
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.$tc("global.words.meeting", 1)) +
                                    "\n            "
                                ),
                              ]
                            ),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        {
                          staticClass: "vertical-center mb-md-0 mb-2",
                          attrs: { cols: "12", md: "auto" },
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "px-2 d-none d-md-inline" },
                            [_vm._v("-")]
                          ),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  _vm._f("momentLocal")(
                                    _vm.createdAt,
                                    "MMM. DD, YYYY"
                                  )
                                ) +
                                " @\n            " +
                                _vm._s(
                                  _vm._f("momentLocal")(_vm.createdAt, "LT")
                                ) +
                                "\n          "
                            ),
                          ]),
                        ]
                      ),
                    ]
                  },
                  proxy: true,
                },
              ]),
            }),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }